// Anchored to a known real new moon (6 Jan 2000, 18:14 UTC) rather than the
// Unix epoch, which was not itself a new moon.
export function getMoonPhase(date = new Date()) {
  const synodicMonth = 29.530588853; // days
  const knownNewMoon = Date.UTC(2000, 0, 6, 18, 14);
  let dayOfMoonCycle =
    ((date.getTime() - knownNewMoon) / (24 * 60 * 60 * 1000)) % synodicMonth;
  if (dayOfMoonCycle < 0) dayOfMoonCycle += synodicMonth;

  if (dayOfMoonCycle < 1.5) return "new";
  if (dayOfMoonCycle < 7.4) return "waxing crescent";
  if (dayOfMoonCycle < 9.4) return "first quarter";
  if (dayOfMoonCycle < 13.5) return "waxing gibbous";
  if (dayOfMoonCycle < 15.5) return "full";
  if (dayOfMoonCycle < 21.4) return "waning gibbous";
  if (dayOfMoonCycle < 23.4) return "last quarter";
  if (dayOfMoonCycle < 29.5) return "waning crescent";
  return "approaching new moon";
}
